import React, { Component } from "react"
import { apiURL } from "../Services/baseURL"
import { push } from "../Services/Analytics"
import { shareFacebook, shareEmail } from "../Services/Sharing"
import { DomCustomImage, DomField, ErrorMsg, DomTextarea, DomCheckboxField } from "../Services/formDOM.jsx"
import { hasValue, returnValue, validateEmail } from "../Services/formHandlers"
import Loading from '../Services/Loading/Loading';
import "./Form.scss"

class Form extends Component {
    constructor() {
        super();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.checkInput = this.checkInput.bind(this);
        this.addState = this.addState.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.state = {
            Takanon: {
                name: "Takanon",
                value: 0
            },
            isLoading: false,
            busy: false,
            isSent: false
        }
    }
    componentDidMount() {
        this.addState("FullName");
        this.addState("Email");
        this.addState("Phone");
        this.addState("Notes");
        this.addState("Age");
    }
    addState(stateName) {
        this.setState({
            [stateName]: {
                name: stateName,
                value: null
            }
        })
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                name: event.target.name,
                value: event.target.value
            }
        })
        if (event.target.name == "Takanon") {
            this.setState({
                Takanon: {
                    name: event.target.name,
                    value: (this.state[event.target.name].value ? 0 : 1),
                }
            })
        }
    }
    setErrorMessage(target, msg) {
        if (this.state[target.name]) {
            this.setState({
                [target.name]: {
                    name: target.name,
                    value: target.value,
                    error: msg
                }
            })
        }
    }
    checkInput(state) {
        var error = "שדה חובה";
        const errors = {
            FullName: "שם מלא לא תקין",
            Email: "דוא\"ל לא תקין",
            Phone: "מספר הטלפון לא תקין",
            Notes: "תוכן הסיפור לא תקין",
            Age: "שדה גיל לא תקין",
            Age_num: "גיל צריך להיות מספר בלבד"
        }
        if (!hasValue(state)) {
            this.setErrorMessage(state, errors[state.name]);
            return false;
        }
        switch (state.name) {
            case "FullName":
                if (state.value.length < 2) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Notes":
                if (state.value.length < 2) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Age":
                if (!isNaN(state.value) != true && state.value.length > 0) {
                    this.setErrorMessage(state, errors[`${state.name}_num`]);
                    return false;
                }
                if (state.value.length < 1) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Phone":
                if (state.value.length < 7 || state.value.length > 15) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Email":
                if (!validateEmail(state.value)) {
                    this.setErrorMessage(state, errors[state.name]);
                    return false;
                }
                break;
            case "Takanon":
                if (state.value != 1) {
                    alert("כדי להמשיך יש להסכים לתקנון");
                    return false;
                }
                break;
        }
        return true;
    }
    sendForm() {
        const state = this.state;
        var error = false;

        if (!this.checkInput(state.Takanon)) {
            alert("כדי להמשיך יש להסכים לתקנון");
            error = true;
        }
        if (!this.checkInput(state.FullName)) {
            error = true;
        }
        if (!this.checkInput(state.Age)) {
            error = true;
        }
        if (!this.checkInput(state.Notes)) {
            error = true;
        }
        if (!this.checkInput(state.Email)) {
            error = true;
        }
        if (error) {
            return;
        }
        if (!state.busy) {
            this.setState({
                busy: true,
                isLoading: true
            })
            push("Button_Clicked", "");

            window.fbq('track', 'MondialSoulPlayerLead');
            
            var google_conversion_id = 854687585;
            window.google_conversion_label = "G2cLCLeOhoQBEOH-xZcD";
            var google_custom_params = window.google_tag_params;
            var google_remarketing_only = true;
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://www.googleadservices.com/pagead/conversion.js?t=' + Math.random();
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', `conv-${Math.random()}`));
            var _image = new Image();
            _image.src = "//googleads.g.doubleclick.net/pagead/viewthroughconversion/854687585/?label=vX8XCOrwjIQBEOH-xZcD&guid=ON&script=0";

            fetch(`${apiURL}save`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    FullName: returnValue(state.FullName),
                    Email: returnValue(state.Email),
                    Notes: returnValue(state.Notes),
                    AcceptedTOS: returnValue(state.Takanon),
                    Age: returnValue(state.Age)
                })
            }).then(data => {
                // this.props.callPopup();
                this.setState({
                    busy: false,
                    isLoading: false,
                    isSent: true,
                    FullName: {
                        name: "FullName",
                        value: " ",
                        error: null
                    },
                    Email: {
                        name: "Email",
                        value: " ",
                        error: null
                    },
                    Age: {
                        name: "Age",
                        value: " ",
                        error: null
                    },
                    Notes: {
                        name: "Notes",
                        value: " "
                    },
                    Takanon: {
                        name: "Takanon",
                        value: 0
                    }
                })
            });
        }
    }
    closePopup() {
        window.location.reload();
    }
    render() {
        return (
            <section className="section section-form">
                <div className="padding">
                    <div className="container">
                        <Loading showLoading={this.state.isLoading} />
                        <div className="thanks" style={{ display: (this.state.isSent ? "block" : "none") }}>
                            <div className="close" onClick={this.closePopup}>
                                <i aria-hidden="true" className="fa fa-close"></i>
                            </div>
                            <span>תודה.</span><br />
                            בהחלט סיפקתם למאמן חומר למחשבה
                        </div>
                        <div style={{ display: (!this.state.isSent ? "block" : "none") }}>
                            <div className="form">
                                <div className="row">
                                    <DomField type="text" placeholder="שם מלא" name="FullName" id="FullName" onChange={this.handleInputChange} {...this.state} />
                                    <DomField type="email" placeholder="אימייל" name="Email" id="Email" onChange={this.handleInputChange} {...this.state} />
                                    <DomField type="tel" placeholder="גיל" name="Age" id="Age" onChange={this.handleInputChange} {...this.state} />
                                </div>
                                <DomTextarea placeholder="מה הסיפור שלכם?" name="Notes" id="Notes" onChange={this.handleInputChange} {...this.state} />
                                <div className="row">
                                    <DomCheckboxField type="checkbox" name="Takanon" id="Takanon" onChange={this.handleInputChange} {...this.state} />
                                </div>
                            </div>
                            <div className="footer" onClick={this.sendForm}>
                                <div className="sendbutton">
                                    שלחו עכשיו ותתחילו להתחמם
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/Components/Body/Form.jsx